import React from "react";

export const AdsComponent = () => {
  return <div id="adslot_banner1" className="adslot mb-3 text-center"></div>;
};
